import React, {useEffect, useState} from 'react';
import Breadcrumbs from '../Components/Breadcrumbs';
import SEO from '../Components/SEO';
import GTM from '../Components/Gtm';
import { createClient } from 'contentful';
import { transformEntryFields } from '../../utils/tokenReplace';
import { useParams } from 'react-router-dom';
import Content from '../Components/Content';
import Casinos from "../Components/Casinos/CasinoList";
import HeroHome from '../Components/HeroHome';

const Default = () => {

  const [singleEntry, setSingleEntry] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const client = createClient({
    space: 'qzvdhv6dk1nu',
    environment: 'master',
    accessToken: 'yF08NDjz2PAvDXY7SsJ57o2vkwpxT1zOjunvfbNOx_4'
  })

  let { slug } = useParams();

  useEffect (() => {
    const getEntries = async () => {
      try {
        const entries = await client.getEntries({
          content_type: "page",
          limit: 1,
          "fields.slug": slug,
        });
        
        entries.items.forEach((item) => {
          transformEntryFields(item);
        });
        

          setSingleEntry(entries);
          setIsDataLoaded(true);

        } catch(error) {
        console.log(error);
      }
    };
    getEntries()

  }, [slug])

  if (!singleEntry) {
    return "Loading...";
  }

  return (
    <div className="container-fluid">
      {singleEntry?.items?.map((entry) =>
      <div className="single-entry single-page" key={entry?.sys?.id}>
        <SEO
        title={entry.fields?.seoFields?.fields?.metaTitle ? entry.fields?.seoFields?.fields?.metaTitle : entry.fields?.title}
        metaTitle={entry.fields?.seoFields?.fields?.metaTitle ?
          entry.fields?.seoFields?.fields?.metaTitle + ' | Casinos Vergleich'
          : entry.fields?.title + ' | Casinos Vergleich'}
        description={entry.fields?.seoFields?.fields?.metaDescription}
        />
        <div>
          {entry.fields?.headerStyle === false ? (
            <HeroHome 
            headline={entry.fields?.headline}
            teaser={entry.fields?.teaser}
            idx={entry.fields?.slug}
            title={entry.fields?.seoFields?.fields?.metaTitle ? entry.fields?.seoFields?.fields?.metaTitle : entry.fields?.title}
            buttons={entry?.fields?.headerButtons ? entry?.fields?.headerButtons : ''}
            />
          ) : (
            <div className="container">         
              <Breadcrumbs active={entry.fields?.title} levels={2} />
              <h1 className="fw-bold mt-4 mb-5">{entry.fields?.title}</h1>
            </div>
          )}
        </div>

        <GTM title={entry.fields?.seoFields?.fields?.metaTitle ? entry.fields?.seoFields?.fields?.metaTitle : ''} />

        {/*Main Content*/}
        <main>

          <div className="container-fluid">

            { entry.fields?.casinoNumber > 1 && isDataLoaded ? (
            <div className="container mb-5">
              { entry.fields?.casinoListTitle ? 
              <h2 className="fw-bold mt-5 mb-5">{entry.fields?.casinoListTitle}</h2>
              : null }
              <Casinos 
              casinos={Casinos} 
              showMore={entry.fields?.showLoadMoreCasinosButton === false ? false : true}
              load={entry.fields?.casinoNumber}/>
            </div>
            )
            : null}

            <div className="container bg-light p-3 p-lg-5 position-relative z-1">
              { isDataLoaded ? <Content id={entry?.sys?.id}></Content> : null }
            </div>
          </div>

        </main>
        {/*end::Main Content*/}

      </div>
)}
    </div>
  )
}

export default Default